import buscarProdutoListener from './BuscarProdutoListener'
import keycloakListener from './KeycloakListener'
import buscarUsuarioLogadoListener from './BuscarUsuarioLogadoListener'
import buscarParametrosListener from './BuscarParametrosListener'
import setFusoHorarioListener from './SetFusoHorarioListener'
import setMenuAvatarListener from './SetMenuAvatarListener'
import setApiArquivoListener from './SetApiArquivoListener'
import setMensagemLoadingListener from './SetMensagemLoadingListener'
import registerGlobalComponentsListener from './RegisterGlobalComponentsListener'
import interceptadorHttp from './InterceptadorHttp'


export default {
    buscarProdutoListener,
    keycloakListener,
    buscarUsuarioLogadoListener,
    buscarParametrosListener,
    setFusoHorarioListener,
    setMenuAvatarListener,
    setApiArquivoListener,
    setMensagemLoadingListener,
    registerGlobalComponentsListener,
    interceptadorHttp
}
